// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__10vtG","amount":"Amount_amount__2y4VH","tip":"Amount_tip__2l8d7","tipHeader":"Amount_tipHeader__1xEwZ","tipsWrap":"Amount_tipsWrap__3V8Vw"};